// src/components/About.js
import React from 'react';

const About = () => {
  return (
    <div id="about" className="bg-gray-800 text-white py-20">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center">About Us</h2>
        <p className="mt-10 text-lg text-center">
          FanCamp is a decentralized platform designed to connect content creators and their fans in a new and engaging way. Our mission is to provide a secure and transparent environment where fans can access exclusive content, and creators can gain valuable insights about their audience.
        </p>
      </div>
    </div>
  );
};

export default About;
